import i18n from "@/i18n";

/**
 * Фильтр даты
 * @param value Исходное значение
 * @param vissible Скрывать или нет цифры в середине
 * @returns Форматированное значение
 */
export default function phoneNumberFilter(value: any, vissible: boolean) {
  /** Пришел ли номер */
  if (!value) return i18n.t("common.errors.undefinedNumber");
  /** Убираем все кроме цифр и знака + из номера */
  value = value.replace(/[^+\d]/g, "");
  /** Запоминаем код страные, если он равен 8 то заменяем на +7 */
  let countryCode = value.toString().substr(0, value.length - 10);
  if (countryCode == "8") countryCode = "+7";
  /** Запоминаем сам номер телефона(10 символов с конца) */
  const formatedPhone = value.toString().substr(value.length - 10);
  /** Делаем из номера массив символов */
  const arr = formatedPhone.split("");
  /** Возвращаем строку заменяя с 3 по 6 символ звездочками, добавляя скобки и тире */
  return (
    countryCode +
    arr.reduce((acc: string, item: string, i: number) => {
      if (i > 2 && i < 7 && !vissible) {
        item = "*";
      }
      if (i === 0) return acc + " (" + item;
      else if (i === 2) return acc + item + ") ";
      else if (i === 5) return acc + item + " - ";
      else if (i === 7) return acc + item + " - ";
      return acc + item;
    }, "")
  );
}
